import React, { FC, ChangeEventHandler, useId, useMemo, ReactNode } from 'react';
import { Textarea, TextareaProps } from '@chakra-ui/react';
import './CustomTextArea.scss';

interface ICustomTextInput {
  label?: string;
  value: string | number | undefined;
  className?: string;
  isDsabled?: boolean;
  classNameInput?: string;
  onChange: ChangeEventHandler<HTMLTextAreaElement>;
  placeholder?: string;
  rightAddon?: ReactNode;
  onClickRightAddon?: () => void;
  propsTextArea?: TextareaProps;
}

const CustomTextArea: FC<ICustomTextInput> = ({
  label,
  onChange,
  value = '',
  propsTextArea,
  isDsabled,
  className,
  classNameInput = '',
  placeholder,
}) => {
  // Stesso fix di BUG-A11Y-008 già applicato a CustomTextInput: la label era
  // uno `<span>` senza associazione semantica (WCAG 1.3.1), quindi il campo
  // risultava senza nome accessibile e `getByLabel` non lo trovava.
  const textAreaId = useId();

  const textAreaMemo = useMemo(
    () => (
      <div className={`container__custom__text__area ${className}`}>
        {label && (
          <label htmlFor={textAreaId} className="label">
            {label}
          </label>
        )}
        <Textarea
          {...(propsTextArea || {})}
          id={textAreaId}
          value={value}
          disabled={isDsabled}
          onChange={onChange}
          placeholder={placeholder}
          className={`custom__input ${classNameInput}`}
        />
      </div>
    ),
    // eslint-disable-next-line
    [value, className, label, textAreaId, isDsabled, placeholder],
  );
  return <>{textAreaMemo}</>;
};

export default CustomTextArea;
